import Colors from "@frog/source/data/colors.js"
import {colortween} from "@frog/source/juice/utility/Tweens.js"
import Loop from "@frog/source/utility/Loop.js"

export default function PercentageHealthBar({unit, nextActionUnit}) {
    const colors = {}
    colors.filled = colors.filled || Colors.red
    colors.empty = colors.empty || Colors.white
    colors.threatened = colors.threatened || Colors.yellow
    colors.threatened2 = colortween(colors.empty, colors.threatened, ((Loop.time % 500) / 500), "hexstring")

    return {
        "width": "100%",
        "height": "100%",
        "_": [
            {
                "stack": 1,
                "color": colors.empty,
                "width": "100%",
                "height": "100%",
                "position": {"x": 0, "y": 0},
            },
            {
                "stack": 2,
                "color": colors.filled,
                "width": Math.max(0, unit.health / unit.maxhealth) * 100 + "%",
                "height": "100%",
                "position": {"x": 0, "y": 0},
            },
            nextActionUnit && {
                "stack": 3,
                "color": colors.threatened2,
                "width": (Math.max(0, unit.health - nextActionUnit.health) / unit.maxhealth) * 100 + "%",
                "height": "100%",
                "position": {
                    "x": (nextActionUnit.health / unit.maxhealth) * 100 + "%",
                    "y": 0
                },
            }
        ]
    }
}
